import store from '../store/index'
//-----------------------
// update arena progress
//-----------------------
export default async function useUpdateArenaProgress(progress) {
  // console.log("---------------------")
  // console.log("useUpdateArenaProgress")
  return new Promise((resolve) => {
    //--------------
    // access store
    //--------------
    const this_store = store
    //-----------------------
    // update arena progress
    //-----------------------
    this_store.dispatch('combat/editCampaignProgress', progress).then((arena) => {
      resolve(arena)
    })
  })
}
